const RightArrowSvg = (): JSX.Element => {
    return (
        <svg width="30" height="40" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.83268 15L6.66602 13.8333L10.4993 10L6.66602 6.16667L7.83268 5L12.8327 10L7.83268 15Z" fill="#545556" />
        </svg>
    );
};

export default RightArrowSvg;
